import { animate, group, keyframes, query, state, style, transition, trigger } from "@angular/animations";

export const slideOutLeft = trigger("slideOutLeft", [
  state(
    "removed",
    style({
      "margin-left": "-3vh",
      transform: "translate3d(-110%, 0, 0)",
    })
  ),
  transition("* => removed", [
    query(":enter, :leave", style({ position: "fixed", width: "100%" }), { optional: true }),
    group([
      query(
        ":enter",
        [style({ transform: "translateX(-100%)" }), animate(".250ms ease-out", style({ transform: "translateX(0%)" }))],
        {
          optional: true,
        }
      ),
      query(
        ":leave",
        [style({ transform: "translateX(0%)" }), animate(".250ms ease-out", style({ transform: "translateX(100%)" }))],
        {
          optional: true,
        }
      ),
    ]),
  ]),
]);

export const slideOutLeftForChildBox = trigger("slideOutLeftForChildBox", [
  state(
    "removed",
    style({
      "margin-left": "-3vh",
      transform: "translate3d(-100%, 0, 0)",
    })
  ),
  transition("* => removed", [animate("250ms ease-out")]),
]);

export const slideInUp = trigger("slideInUp", [
  state(
    "upside",
    style({
      transform: "translate3d(0, 0%, 0)",
    })
  ),
  state(
    "downside",
    style({
      "margin-top": "100vh",
    })
  ),
  transition("* => upside", [animate("1000ms ease-in")]),
  transition("* => downside", [animate("0ms")]),
]);

export const fadeText = trigger("fadeText", [
  state(
    "blur",
    style({
      opacity: 0,
    })
  ),
  state(
    "normal",
    style({
      opacity: 1,
    })
  ),
  transition("* => blur", [animate("300ms ease-in")]),
  transition("* => normal", [animate("300ms ease-in")]),
]);

export const reduceHeight = trigger("reduceHeight", [
  state(
    "reduce",
    style({
      height: 0,
      margin: 0,
      padding: 0,
    })
  ),
  transition("* => reduce", [animate("200ms")]),
]);

export const bounceIn = trigger("bounceIn", [
  transition(":enter", [
    style({ transform: "scale(0.5)", opacity: 0 }),
    animate(
      "1s cubic-bezier(.8, -0.6, 0.2, 1.5)",
      keyframes([
        style({ transform: "scale(0.3) translate3d(0,0,0)", opacity: 0 }),
        style({ transform: "scale(1.1)", opacity: 0.9 }),
        style({ transform: "scale(0.89)", opacity: 1 }),
        style({ transform: "scale(1) translate3d(0,0,0)", opacity: 1 }),
      ])
    ),
  ]),
]);

export const fadeInbottomRight = trigger("fadeInbottomRight", [
  state(
    "left",
    style({
      opacity: 0,
      transform: "scale(0)",
      transformOrigin: "100% 100%"
    })
  ),
  state(
    "top",
    style({
      opacity: 1,
      transform: "scale(1)",
      transformOrigin: "100% 100%"
    })
  ),
  transition("*=>left", [
    animate(
      "0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530)",
      style({ transform: "scale(0)", transformOrigin: "100% 100%", opacity: 0 })
    ),
  ]),
  transition("*=>top", [
    animate(
      "0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940)",
      style({ transform: "scale(1)", transformOrigin: "100% 100%", opacity: 1 })
    ),
  ]),
]);

export const scaleIn = trigger("scaleIn", [
  transition(":enter", [
    animate(
      "0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940)",
      keyframes([style({ transform: "scale(0)", opacity: 1 }), style({ transform: "scale(1)", opacity: 0 })])
    ),
  ]),
]);

export const flipIn = trigger("flipIn", [
  state(
    "start",
    style({
      opacity: 1,
    })
  ),
  state(
    "secondStart",
    style({
      opacity: 1,
    })
  ),
  state(
    "end",
    style({
      opacity: 1,
    })
  ),
  transition("* => start", [
    animate(
      "0.6s cubic-bezier(0.455, 0.030, 0.515, 0.955)",
      keyframes([style({ transform: "rotateY(0)" }), style({ transform: "rotateY(-180deg)" })])
    ),
  ]),
  transition("* => secondStart", [
    animate(
      "0.5s 1s cubic-bezier(0.455, 0.030, 0.515, 0.955)",
      keyframes([style({ transform: "rotateY(0)" }), style({ transform: "rotateY(-360deg)" })])
    ),
  ]),
  transition("* => end", [
    animate(
      "0.6s cubic-bezier(0.455, 0.030, 0.515, 0.955)",
      keyframes([style({ transform: "rotateY(-180deg)" }), style({ transform: "rotateY(0)" })])
    ),
  ]),
]);

/* Games page - Bottom Sheet Animation */
export const bottomSheetSlideUp = trigger("bottomSheetSlideUp", [
  state("bottomSheetSlideUp", style({
    bottom: "0vh"
  })),
  state("bottomSheetSlideDown", style({
    bottom: "-9vh"
  })),
  transition("* => bottomSheetSlideUp", [animate("200ms")]),
  transition("* => bottomSheetSlideDown", [animate("200ms")]),
]);
export const gamethumbBounceIn = trigger("gamethumbBounceIn", [
  transition(":enter", [
    style({ transform: "scale(1)" }),
    animate(
      "1s 1s",
      keyframes([
        style({ transform: "scale(1)" }),
        style({ transform: "scale(1.25)" }),
        style({ transform: "scale(0.85)" }),
        style({ transform: "scale(1)" }),
      ])
    ),
  ]),
]);
